
<template>
  <!-- 加入项目 -->
  <div>
    <z-dialog @close="closeDialog" @submit="createProject">
      <Row type="flex" justify="space-between" :class="preflxCls">
        <Col
          :class="lists.length > 0 && !lists[0].specFile ? preflxCls+'-left' :  preflxCls+'-left-specail'"
          span="9"
        >
          <div
            v-if="lists.length > 0 && !lists[0].specFile && (lists[0].key || lists[0].partFiles)"
          >
            <div v-for="(item, index) in lists" :key="index" :class="preflxCls+ '-left-item'">
              <z-panelimg
                v-if="!item.partFiles"
                :src="item.key ? ossKey + item.key : ''"
                cover
                width="87"
                height="87"
                :del="false"
              ></z-panelimg>
              <z-panelimg
                v-else
                :src="ossKey + item.partFiles[0].key"
                cover
                width="87"
                height="87"
                :del="false"
              ></z-panelimg>
            </div>
          </div>
          <div v-if="lists.length > 0 && lists[0].specFile">
            <div
              v-for="(item, index) in lists"
              :key="index"
              :class="preflxCls+ '-left-specail-item'"
            >
              <img v-if="item.specFile" :src="ossKey + item.specFile.key" alt />
              <p class="name">{{item.name}}</p>
              <p class="code">{{item.code}}</p>
            </div>
          </div>
          <div v-if="lists.length === 1 && !lists[0].specFile && !lists[0].key">
            <div
              v-for="(item, index) in lists"
              :key="index"
              :class="preflxCls+ '-left-specail-item'"
            >
              <span class="no-img"></span>
              <p class="name">{{item.name}}</p>
              <p class="code">{{item.code}}</p>
            </div>
          </div>
        </Col>
        <Col :class="preflxCls+'-right'" span="15">
          <div :class="preflxCls+'-right-main'">
            <p class="title">选择项目</p>
            <Input
              placeholder="请输入关键词搜索项目"
              v-model="keyword"
              search
              class="search-input"
              :maxlength="50"
              @on-enter="searcHandle"
            >
              <Icon type="ios-search" slot="suffix" />
            </Input>
            <div :class="preflxCls+'-right-main-items'">
              <div style="padding:0 20px 0 0;" v-if="projects.length > 0 && !allLoading">
                <Row
                  v-for="(item, index) in projects"
                  :key="index"
                  type="flex"
                  @click.native="addProjectHandle(item, index)"
                  :class="!item.hasInquiry && item.hasQuoteInquiry ? 'row-item-active' : ''"
                  justify="start"
                  align="middle"
                  class="row-item"
                >
                  <Col span="21" class="projectsTitle">{{item.name}}</Col>
                  <Col span="3" v-if="item.originFileId">
                    <i
                      v-if="item.hasInquiry"
                      style="font-size:20px;margin-left:18px;"
                      class="iconfont icon-tianjiaxiangmu"
                    ></i>
                    <span class="ing" v-else>询价中</span>
                  </Col>
                  <Col span="3" v-else>
                    <i
                      v-if="!item.hasQuoteInquiry"
                      style="font-size:20px;margin-left:18px;"
                      class="iconfont icon-tianjiaxiangmu"
                    ></i>
                    <span class="ing" v-else>询价中</span>
                  </Col>
                </Row>
              </div>
              <Row
                v-if="allLoading"
                type="flex"
                justify="center"
                align="middle"
                class="align-center loading-block"
              >
                <Spin size="large"></Spin>
                <Spin size="large" class="m-l-20"></Spin>
                <Spin size="large" class="m-l-20"></Spin>
              </Row>

              <div v-if="projects.length === 0 && !allLoading" style="text-align:center;">
                <z-empty :txt="keyword ? '搜索不到项目，赶快创建吧' : '还没有创建项目，赶快创建吧'"></z-empty>
                <Button type="primary" @click="createProject">创建项目</Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </z-dialog>
  </div>
</template>

<script>
const preflxCls = "zInprojectlog";
import { findComponentDownward } from "../../utils/assist.js";
import ZDialog from "./dialog";
import ZPanelimg from "../panelimg/panelimg";
import Zempty from "../empty";
export default {
  name: "ZInprojectlog",
  provide() {
    return {
      app: this
    };
  },
  data() {
    return {
      preflxCls: preflxCls,
      keyword: "",
      model: false
    };
  },
  props: {
    display: {
      type: Boolean,
      default: false
    },
    allLoading: {
      type: Boolean,
      default: false
    },
    // 图片list
    lists: {
      type: [Array, Object],
      default: function() {
        return [];
      }
    },
    // 所有项目
    projects: {
      type: Array,
      default: function() {
        return [];
      }
    },
    ossKey: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 360
    },
    // button text
    btnTxt: {
      type: [Number, String],
      default: "确定"
    },
    // 是否是长按钮
    long: {
      type: Boolean,
      default: false
    },
    // 是否需要取消
    cel: {
      type: Boolean,
      default: false
    },
    // 不显示底部
    footerHide: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: "specailDialog"
    }
  },
  components: { ZDialog, ZPanelimg, Zempty },

  methods: {
    closeDialog() {
      this.$emit("close");
    },
    searcHandle() {
      this.$emit("search", this.keyword);
    },

    // 加入项目
    addProjectHandle(item, index) {
      if (item.loading) {
        return false;
      }
      if (!item.hasInquiry && item.hasQuoteInquiry) {
        return false;
      }
      this.$emit("addProject", { params: item, _i: index });
    },

    // 弹框内创建项目
    createProject() {
      this.$emit("insertCreatePro");
    }
  },

  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  },
  watch: {
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    }
  }
};
</script>

